export const API_URL = process.env.REACT_APP_BACKEND_URL

export const API_ROUTES = {
    GET_SETTINGS: `/settings`,
    CREATE_BANNER: "/banner/create",
    EDIT_BANNER: "/banner/edit",
    UPDATE_SORT_ID: "/update-sort-id",
    DELETE_BANNER: "/banner/delete",
}
